/**
 * Deletes cookie based on given cookie name
 * @param {string} name  cookie name
 */

export const deleteCookie = (name: string) => {
  if (typeof window === 'undefined') {
    return null
  }
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
}
